import React, {useEffect} from "react";

//css

import "bootstrap/dist/css/bootstrap.min.css";
import {Col, Container, Row, Card} from "react-bootstrap";

//ant design
import "antd/dist/antd.css";
import {Modal, Button, Form, Input} from "antd";

//navbar
import Navbar from "./NavBar";

//firebase
import {db} from "../firebase/firebase";
import firebase from "firebase";

//toast
import {alert} from "../util/toast";

const UserProfile = () => {
  const [form] = Form.useForm();
  const userData = JSON.parse(localStorage.getItem("Detail"));
  const _id = localStorage.getItem("id");

  useEffect(() => {
    form.setFieldsValue({
      username: userData.name,
      email: userData.email,
    });
  }, [userData, form]);

  const onFinish = async (val) => {
    const data = {name: val.username, email: val.email};

    const query = await db
      .collection("users")
      .where("_id", "==", parseInt(_id))
      .get();

    const userFirebaseId = query.docs[0].id;

    const user = await db.doc(`/users/${userFirebaseId}`).update(data);

    localStorage.setItem("Detail", JSON.stringify(data));

    alert("success", "Profile Updated successfully");
  };

  return (
    <>
      {/* <Navbar /> */}
      {/* <div className="bgColor">
        <Container fluid="sm"> */}
      {/* <Row className="py-5"> */}
      <Col lg={3}></Col>
      <Col className="py-3">
        <Card className="cardBg shadow-lg mx-auto " style={{borderRadius: 15}}>
          <Card.Body>
            <Card.Title className="py-2 px-3 border-bottom  font-weight-bold">
              <h2 className="text-center">My Info</h2>
            </Card.Title>

            <Row className="pt-4 px-4">
              <Form
                form={form}
                name="normal_login"
                className="login-form w-100"
                layout="vertical"
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
              >
                <Form.Item
                  name="username"
                  // className="profileInput"
                  initialValue={{remember: true}}
                  rules={[
                    {
                      required: true,
                      message: "Please input your Username!",
                    },
                  ]}
                  requiredMark="optional"
                >
                  <Input placeholder="Username" />
                </Form.Item>
                <Form.Item
                  name="email"
                  initialValue={{remember: true}}
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email!",
                    },
                  ]}
                  requiredMark="optional"
                >
                  <Input placeholder="Email" disabled className="text-dark" />
                </Form.Item>

                <div className="m-auto " style={{textAlign: "center"}}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="mt-3 shadow-lg btn"
                  >
                    Edit Profile
                  </Button>
                </div>
              </Form>
            </Row>
          </Card.Body>
        </Card>
      </Col>
      <Col lg={3}></Col>
      {/* </Row> */}
      {/* </Container>
      </div> */}
    </>
  );
};

export default UserProfile;
